import { __assign, __awaiter, __generator } from "tslib";
import { PageMap } from '@wix/wixstores-client-core';
import { MinicartActions } from '../../../actions/MiniCartActions/MinicartActions';
import { TinyCartActions } from '../../../actions/TinyCartActions/TinyCartActions';
import { SideCartActions } from '../../../actions/SideCartActions/SideCartActions';
import { SPECS } from '../../../constants';
import { intToGuid } from '../../../utils/intToGuid';
import { getLeanGQLCartFromCart } from '../../current-cart-service/getLeanGQLCartFromCart';
import { getLeanGQLCartFromCartV1 } from '../../current-cart-service/getLeanGQLCartFromCartV1';
import { loadMiniCartIfNotLoaded } from '../../../utils/miniCart.utils';
export function createCartExports(_a) {
    var _this = this;
    var context = _a.context, origin = _a.origin;
    var getMiniCartActions = function (siteStore) { return new MinicartActions({ siteStore: siteStore, origin: origin }); };
    var getSideCartActions = function (siteStore) { return new SideCartActions({ siteStore: siteStore, origin: origin }); };
    var getTinyCartActions = function (siteStore) { return new TinyCartActions({ siteStore: siteStore, origin: origin, context: context }); };
    var hideMiniCart = function () {
        if (context.siteStore.isMobile()) {
            throw Error("can't handle mini cart in mobile");
        }
        getMiniCartActions(context.siteStore).hideMinicart();
    };
    var openSideCartOrMiniCart = function (options) {
        if (options === void 0) { options = { allowShowingSideCartOnMobile: false }; }
        return __awaiter(_this, void 0, void 0, function () {
            var sideCartActions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sideCartActions = getSideCartActions(context.siteStore);
                        return [4 /*yield*/, sideCartActions.hasSideCart()];
                    case 1:
                        if (!(!(_a.sent()) &&
                            !context.siteStore.experiments.enabled(SPECS.NavigateToCartWhenCallShowMiniCart))) return [3 /*break*/, 3];
                        return [4 /*yield*/, loadMiniCartIfNotLoaded(context)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, sideCartActions.showMiniCartOrSideCart(options)];
                }
            });
        });
    };
    return {
        getCurrentCart: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (context.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
                    return [2 /*return*/, getLeanGQLCartFromCart({
                            currentCartService: context.currentCartService,
                            wixApi: context.wixApi,
                            platformServices: context.platformServices,
                            calculateCoupon: true,
                        })];
                }
                return [2 /*return*/, getLeanGQLCartFromCartV1(context.currentCartService, context.siteStore)];
            });
        }); },
        onChange: function (listener) {
            return context.currentCartService.onChange(listener);
        },
        removeProduct: function (cartItemId, _options) {
            if (_options === void 0) { _options = { silent: false }; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, context.currentCartService.removeLineItemV1({ lineItemId: intToGuid(Number(cartItemId)) }, { origin: origin })];
                });
            });
        },
        /**
         * @deprecated. use cart.addToCurrentCart instead
         */
        addProducts: function (items, options) {
            if (options === void 0) { options = { silent: false }; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (context.siteStore.experiments.enabled(SPECS.DeprecateCartActions)) {
                        return [2 /*return*/, undefined];
                    }
                    return [2 /*return*/, context.currentCartService.cartActions.addProductsToCart(items, __assign({ origin: origin }, options))];
                });
            });
        },
        /**
         * @deprecated. use cart.addToCurrentCart instead
         */
        addToCart: function (productId, quantity, options, preOrderRequested, trackData) {
            if (options === void 0) { options = {}; }
            if (preOrderRequested === void 0) { preOrderRequested = undefined; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (context.siteStore.experiments.enabled(SPECS.DeprecateCartActions)) {
                                return [2 /*return*/, undefined];
                            }
                            return [4 /*yield*/, context.currentCartService.cartActions.addToCart({
                                    productId: "".concat(productId),
                                    quantity: parseInt("".concat(quantity), 10),
                                    optionsSelectionsByNames: options.choices,
                                    customTextFieldSelections: options.customTextFields,
                                    optionsSelectionsIds: options.optionsSelectionsIds,
                                    variantId: options.variantId,
                                    subscriptionOptionId: options.subscriptionOptionId,
                                    addToCartAction: options.addToCartAction,
                                    preOrderRequested: preOrderRequested,
                                }, __assign(__assign({}, trackData), { origin: origin }))];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        addToCurrentCart: function (options) {
            return context.currentCartService.addToCurrentCartV1(options);
        },
        applyCoupon: function (couponCode) {
            return context.currentCartService.applyCouponV1({ code: couponCode }, { origin: origin });
        },
        removeCoupon: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, context.currentCartService.removeCouponV1({ origin: origin })];
            });
        }); },
        updateLineItemQuantity: function (cartItemId, quantity, _options) {
            if (_options === void 0) { _options = { silent: false }; }
            return context.currentCartService.updateLineItemQuantityV1({ lineItemId: intToGuid(cartItemId), quantity: quantity }, { origin: origin });
        },
        showMinicart: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, openSideCartOrMiniCart()];
        }); }); },
        hideMinicart: hideMiniCart,
        openSideCart: function (options) {
            if (options === void 0) { options = { allowShowingSideCartOnMobile: false }; }
            return openSideCartOrMiniCart(options);
        },
        showTinycart: function (options) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (context.siteStore.isMobile()) {
                            throw Error("can't open success popup in mobile");
                        }
                        return [4 /*yield*/, loadMiniCartIfNotLoaded(context)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, getTinyCartActions(context.siteStore).showTinyCart(options)];
                }
            });
        }); },
        hideTinycart: function () {
            if (context.siteStore.isMobile()) {
                throw Error("can't open success popup in mobile");
            }
            getTinyCartActions(context.siteStore).hideTinyCart();
        },
        reloadCart: function () {
            return context.currentCartService.invalidateAndReload();
        },
        hasSideCart: function () { return getSideCartActions(context.siteStore).hasSideCart(); },
        hasCartIcon: function () { return Promise.resolve(context.siteStore.isCartIconExists); },
        preloadTinyCart: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, loadMiniCartIfNotLoaded(context)];
            });
        }); },
        preloadSideCart: function () { return __awaiter(_this, void 0, void 0, function () {
            var sideCartActions, sideCartName;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sideCartActions = getSideCartActions(context.siteStore);
                        return [4 /*yield*/, sideCartActions.getSideCartName()];
                    case 1:
                        sideCartName = _a.sent();
                        if (!sideCartName && context.siteStore.experiments.enabled(SPECS.NavigateToCartWhenCallShowMiniCart)) {
                            return [2 /*return*/];
                        }
                        if (!sideCartName) {
                            return [2 /*return*/, loadMiniCartIfNotLoaded(context)];
                        }
                        context.siteStore.siteApis.prefetchPageResources({
                            lightboxes: [sideCartName],
                        });
                        return [2 /*return*/];
                }
            });
        }); },
        preloadCartPage: function () { return __awaiter(_this, void 0, void 0, function () {
            var sectionUrl, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, context.siteStore.getSectionUrl(PageMap.CART)];
                    case 1:
                        sectionUrl = _a.sent();
                        if (sectionUrl.relativeUrl) {
                            context.siteStore.siteApis.prefetchPageResources({ pages: [sectionUrl.relativeUrl] });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error('failed to prefetch cart page', e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    };
}
//# sourceMappingURL=wixcode.cart.js.map